<template>
  <div class="OrderDetails" style="padding:30px; background: #FFFFFF;
    box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
    border-radius: 10px;">
    <p class="comeback" @click="comeback()">
      <span class="el-icon-arrow-left"></span>
      <span>返回</span>
    </p>
    <div class="RequestInfo divbox" style="    margin: 3px 29px;">
      <h4>委托信息</h4>
      <ul class="RI_ul" v-if="Alldata.waybilldetails">
        <li>
          <p>
            <span>运单号</span><span>{{ routes.nos || "-" }}</span>
          </p>

          <p>
             <span>委托日期
            </span>
            <span>{{ Alldata.waybilldetails.inputtime || "-" }}
            </span>


          </p>
        </li>
        <li>
          <!-- <p>
                        <span>发货人</span><span>{{Alldata.message.shipper_name|| '-'}}</span>
                    </p>
                    <p>
                        <span>收货人</span><span>{{Alldata.message.cneename|| '-'}}</span>
                    </p>
                    <p>
                        <span>提货人</span><span>{{Alldata.message.getgoodsname|| '-'}}</span>
                    </p> -->
          <p >

              <span>起运仓库
            </span>
            <span>{{ Alldata.waybilldetails.warehouse || "-" }}
            </span>
          </p>

          <p>
            <span>入仓确认日期</span
            ><span>{{ Alldata.waybilldetails.inwarehousetime || "-" }}</span>
          </p>
        </li>
        <li>
          <p>
            <span>目的仓库</span
            ><span>{{ Alldata.waybilldetails.pod_country || "-" }}</span>
          </p>

          <!-- <p>
            <span>入仓确认日期</span
            ><span>{{ Alldata.waybilldetails.inwarehousetime || "-" }}</span>
          </p> -->
          <!-- <p>
                        <span>货物类型</span><span>{{Alldata.message.goodstype|| '-'}}</span>
                    </p>
                    <p>
                        <span>收货地址</span><span :title="Alldata.message.rece_address">{{Alldata.message.rece_address|| '-'}}</span>
                    </p>
                    <p>
                        <span>提货地址</span><span>{{Alldata.message.getgoodsaddress|| '-'}}</span>
                    </p> -->
        </li>
      </ul>
    </div>
      <!-- jack start -->
    <div class="jackCard" style="padding: 20px"  v-if="Alldata.message.isgetgoodstodoor">
      <div style="display: flex; align-items: center">
        <img style="" src="./../../../assets/receiveIcon.png" alt="提货信息" />
        <span style="margin-left: 10px; font-size: 20px; font-weight: 550"
          >提货信息</span
        >
      </div>
       <div
        style="
          margin: 20px 30px 5px;
          padding: 0 10px;
          height: 40px;
          border: 1px solid #FF4D01;
          background: rgb(235 232 251);
        "
      >
        <span style="font-size: 18px; line-height: 40px; font-weight: 600">
          {{ Alldata.message.getgoodsname || "暂无收货信息" }}
        </span>
        <span style="line-height: 40px"
          >{{ Alldata.message.getgoodstel || "" }}
          {{ Alldata.message.getgoodsprovince || "" }}
          {{ Alldata.message.getgoodscity || "" }}
          {{ Alldata.message.getgoodsarea || "" }}
          {{ Alldata.message.getgoodsaddress || "" }}</span
        >
      </div>
    </div>
     <!-- jack start -->
    <div class="jackCard" style="padding: 20px">
      <div style="display: flex; align-items: center">
        <img style="" src="./../../../assets/receiveIcon.png" alt="收货信息" />
        <span style="margin-left: 10px; font-size: 20px; font-weight: 550"
          >收货信息</span
        >
      </div>
      <div
        style="
          margin: 20px 30px 5px;
          padding: 0 10px;
          height: 40px;
          border: 1px solid #FF4D01;
          background: rgb(235 232 251);
        "
      >
        <span style="font-size: 18px; line-height: 40px; font-weight: 600">
          {{ Alldata.message.cneename || "暂无收货信息" }}
        </span>
        <span style="line-height: 40px"
          >{{ Alldata.message.rece_tel || "" }}
          {{ Alldata.message.rece_country || "" }}
          {{ Alldata.message.rece_city || "" }}

          {{ Alldata.message.rece_address || "" }}</span
        >
      </div>
    </div>
    <!-- jack start -->
    <div class="jackCard" style="padding: 20px">
      <div style="display: flex; align-items: center">
        <img style="" src="./../../../assets/receiveIcon.png" alt="收货信息" />
        <span style="margin-left: 10px; font-size: 20px; font-weight: 550"
          >收货信息</span
        >
      </div>
      <div
        style="
          margin: 20px 30px 5px;
          padding: 0 10px;
          height: 40px;
          border: 1px solid #FF4D01;
          background: rgb(235 232 251);
        "
      >
        <span style="font-size: 18px; line-height: 40px; font-weight: 600">
          {{ Alldata.message.cneename || "暂无收货信息" }}
        </span>
        <span style="line-height: 40px"
          >{{ Alldata.message.rece_tel || "" }}
          {{ Alldata.message.rece_country || "" }}
          {{ Alldata.message.rece_city || "" }}

          {{ Alldata.message.rece_address || "" }}</span
        >
      </div>
    </div>

    <div
      v-if="!Alldata.message.isgetgoodstodoor"
      class="jackCard"
      style="
        overflow: hidden;
        margin: 20px 0 20px 30px;
        background: rgb(253 246 217);
      "
    >
      <div style="padding: 10px 30px">
        <span
          style="
            font-size: 26rpx;
            font-family: PingFang SC;
            font-weight: 500;
            color: #c19822;
            line-height: 40rpx;
          "
          >请将货物送至以下仓库</span
        >
      </div>
      <div style="background: #fff; padding: 15px 30px">
        <span
          style="font-size: 16px;
                                font-family: PingFang SC;
                                font-weight:550
                                line-height: 40px;"
        >
          {{ Alldata.depwarehouse.warehouse || "" }}
        </span>
        <span style="margin: 0 10px">
          {{ Alldata.depwarehouse.tel || "" }}
        </span>
        {{ Alldata.depwarehouse.province || "" }}
        {{ Alldata.depwarehouse.city || "" }}
        {{ Alldata.depwarehouse.area || "" }}
        {{ Alldata.depwarehouse.address || "" }}
      </div>
    </div>

    <div
      v-if="!Alldata.message.issendgoodstodoor"
      class="jackCard"
      style="
        overflow: hidden;
        margin: 20px 0 20px 30px;
        background: rgb(253 246 217);
      "
    >
      <div style="padding: 10px 30px">
        <span
          style="
            font-size: 26rpx;
            font-family: PingFang SC;
            font-weight: 500;
            color: #c19822;
            line-height: 40rpx;
          "
          >请到以下目的地仓库提取货物</span
        >
      </div>
      <div style="background: #fff; padding: 5px 30px">
        <span
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 550;
            line-height: 40px;
          "
        >
          {{ Alldata.deswarehouse.warehouse || "" }}
        </span>
        <span style="margin: 0 10px">
          {{ Alldata.deswarehouse.tel || "" }}
        </span>
        {{ Alldata.deswarehouse.province || "" }}
        {{ Alldata.deswarehouse.city || "" }}
        {{ Alldata.deswarehouse.area || "" }}
        {{ Alldata.deswarehouse.address || "" }}
      </div>
    </div>
    <!-- jack end  -->
    <div class="Blurb">
      <div class="tablebox">
        <h4>商品预报信息</h4>
        <el-table
          border
          :data="tableData_C1"
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F3F3F3' }"
          ref="multipleTable"
          :summary-method="getSummaries"
          show-summary
          style="width: 94%; margin-left: 25px; margin-top: 20px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="index"
            label="序号"
            width="75px"
            min-width="8%"
          ></el-table-column>
          <el-table-column prop="goodname" label="商品名称"></el-table-column>
          <el-table-column prop="goodstype" label="货物类型"></el-table-column>

          <el-table-column
            prop="weight"
            label="预报重量(kgs)"
          ></el-table-column>
          <el-table-column prop="cbm" label="预报体积(cbm)"></el-table-column>
          <el-table-column prop="piece" label="预报数量"></el-table-column>
        </el-table>
      </div>
      <div class="tablebox">
        <h4>商品入仓信息</h4>
        <el-table
          border
          :data="tableData_C2"
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F3F3F3' }"
          ref="multipleTable"
          :summary-method="getSummaries"
          show-summary
          style="width: 94%; margin-left: 25px; margin-top: 20px"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="index"
            label="序号"
            width="75px"
            min-width="8%"
          ></el-table-column>
          <el-table-column prop="goodname" label="商品名称"></el-table-column>
          <el-table-column
            prop="weight"
            label="入仓重量(kgs)"
          ></el-table-column>
          <el-table-column prop="cbm" label="入仓体积(cbm)"></el-table-column>
          <el-table-column prop="piece" label="入仓数量"></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="Information divbox">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="船期信息" name="first">
          <ul class="RI_ul" v-if="Alldata.waybilldetails">
            <li>
              <p>
                <span>船名</span
                ><span>{{ Alldata.schedule.vessel || "-" }}</span>
              </p>
              <p>
                <span>船次</span
                ><span>{{ Alldata.schedule.voyage || "-" }}</span>
              </p>
              <p>
                <span>起运港</span
                ><span>{{ Alldata.schedule.pol || "-" }}</span>
              </p>
              <p>
                <span>航线</span
                ><span>{{ Alldata.schedule.route || "-" }}</span>
              </p>
            </li>
            <li>
              <p>
                <span>预计开船</span
                ><span>{{ Alldata.schedule.etd || "-" }}</span>
              </p>
              <p>
                <span>预计到港</span
                ><span>{{ Alldata.schedule.eta || "-" }}</span>
              </p>
              <p>
                <span>目的港</span
                ><span>{{ Alldata.schedule.pod || "-" }}</span>
              </p>
            </li>
            <li>
              <p>
                <span>实际开船</span
                ><span>{{ Alldata.schedule.atd || "-" }}</span>
              </p>
              <p>
                <span>实际到港</span
                ><span>{{ Alldata.schedule.ata || "-" }}</span>
              </p>
              <p>
                <span>截关日</span
                ><span>{{ Alldata.schedule.cls || "-" }}</span>
              </p>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label="费用信息" name="second">
          <el-table
            border
            :data="tableData1"
            tooltip-effect="dark"
            :header-cell-style="{ background: '#F3F3F3' }"
            ref="multipleTable"
            style="width: 77%; margin-left: 25px; border-bottom: none"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              type="index"
              label="序号"
              width="75px"
              min-width="8%"
            >
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.feeitem !== '合计' &&
                    scope.row.feeitem !== '折合人民币'
                  "
                  >{{ parseInt(scope.$index + 1) }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="feeitem"
              label="费用项"
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="amountBefore"
              label="预估费用"
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="amount"
              label="实际费用"
              min-width="8%"
            ></el-table-column>
          </el-table>
          <el-table
            border
            :data="twotableData"
            style="
              width: 77%;
              margin-left: 25px;
              border-top: none;
              margin-top: 0px;
            "
            :cell-style="{ padding: '5px 0px' }"
            :show-header="false"
          >
            <el-table-column type="index" label="" width="75px" min-width="8%">
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.feeitem !== '合计' &&
                    scope.row.feeitem !== '折合人民币'
                  "
                  >{{ parseInt(scope.$index + 1) }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="feeitem"
              label=""
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="amountBefore"
              label=""
              min-width="8%"
            ></el-table-column>
            <el-table-column
              prop="amount"
              label=""
              min-width="8%"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="轨迹信息" name="third">
          <p
            v-if="guiji"
            style="text-align: center; padding-top: 50px; font-size: 16px"
          >
            暂无轨迹信息
          </p>
          <el-timeline v-else>
            <el-timeline-item
              type="primary"
              v-for="(activity, index) in activities"
              :key="index"
              :icon="activity.icon"
              :color="activity.color"
              :timestamp="activity.timestamp"
            >
              {{ activity.state }}
              <p style="font-size: 11px; color: #999999; margin-top: 6px">
                {{ activity.address }}
              </p>
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "AirOrderDetail",
  data() {
    return {
      tableData_C1: [
        {
          goodname: "衣服",
          weight: "50",
          cbm: "3",
          piece: "200",
        },
      ],
      tableData_C2: [
        {
          goodname: "衣服",
          weight: "50",
          cbm: "3",
          piece: "200",
        },
      ],
      tableData1: [
        {
          feeitem: "海运费",
          amountBefore: "CNY 50",
          amount: "CNY 30",
        },
      ],
      twotableData: [
        {
          feeitem: "合计",
          amountBefore: "CNY 50",
          amount: "CNY 30",
        },
        {
          feeitem: "合计",
          amountBefore: "CNY 50",
          amount: "CNY 30",
        },
      ],
      Alldata: {
        message: {
          cneename: "",
          getgoodsaddress: "",
          getgoodsarea: "",
          getgoodscity: "",
          getgoodsname: "",
          getgoodsprovince: "",
          getgoodstel: "",
          goodstype: "",
          id: "",
          inputtime: "",
          inwarehoustime: "",
          ischangeaddress: true,
          isgetgoodstodoor: true,
          issendgoodstodoor: true,
          pod_country: "",
          pod_country_area: "",
          rece_address: "",
          rece_city: "",
          rece_country: "",
          rece_tel: "",
          shipper_name: "",
          shipper_tel: "",
        },
      },
      routes: {},
      activeName: "first",
      reverse: false,
      activities: [
        {
          state: "活动按期开始",
          timestamp: "2020-05-30 15:00",
          address: "迪拜",
          // color: '#4B7AF5'
        },
      ],
      guiji: false,
    };
  },
  watch: {},
  methods: {
    getSummaries(param) {
      //合计第一列不显示合计
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        }
      });
      return sums;
    },
    comeback() {
      //返回上一页
      this.$router.push({ name: "AirOrder", query: {} });
    },
    handleSelectionChange(val) {
      //table方法
      this.multipleSelection = val;
    },
    handleClick(tab, event) {
      //tabs的点击方法
      // console.log(tab, event);
    },
    getalldata() {
      let data = {
        jobtype: "D",
        language: "CN",
        // "nos": this.routes.nos,
        nos: this.routes.nos,
        state: this.routes.state,
      };
      // console.log(data)
      let that = this;
      that.axios
        .post("/busKY/getKyJobsHistoryWebSingleList", data)
        .then((response) => {
          console.log(response.data.data);
          that.Alldata = response.data.data;
          that.tableData_C1 = response.data.data.cargobefore;
          that.tableData_C2 = response.data.data.cargo;
          that.tableData1 =
            response.data.data.combincostinfo.combinCostinfoList; //数据列表
          that.twotableData = [
            {
              feeitem: "合计",
              amountBefore: response.data.data.combincostinfo.totalCostBefore,
              amount: response.data.data.combincostinfo.totalCost,
            },
            {
              feeitem: "折合人民币",
              amountBefore: response.data.data.combincostinfo.amountBefore,
              amount: response.data.data.combincostinfo.amount,
            },
          ];
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    CargoTrackByNo() {
      let data = {
        language: "CN",
      };
      // let that = this;
      this.axios
        .post(
          "/track/queryCargoTrackByNo/" + this.routes.nos,
          {},
          { headers: { language: "CN" } }
        )
        .then((response) => {
          this.activities = response.data.datas;
          // console.log(this.activities);
          if (this.activities == null) {
            this.guiji = true;
          } else if (
            this.activities.length !== null &&
            this.activities.length > 0
          ) {
            this.guiji = false;
            for (var i = 0; i < this.activities.length; i++) {
              this.activities[i].timestamp =
                this.activities[i].date + " " + this.activities[i].time;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  created() {
    this.routes = this.$route.query;
  },
  mounted() {
    this.CargoTrackByNo();
    this.getalldata();
  },
};
</script>

<style scoped>
.jackCard {
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  margin: 20px 0 20px 30px;
  background: #ffffff;
}
.OrderDetails {
  width: 100%;
  /* background: #FBFBFB; */
  border-radius: 5px;
}
.OrderDetails .comeback {
  width: 120px;
  margin-bottom: 5px;
  font-size: 18px;
  cursor: pointer;
}
.OrderDetails .comeback:hover {
  color: #409eff;
}
.OrderDetails .comeback span:nth-child(1) {
  margin-left: 12px;
  margin-right: 5px;
  font-size: 22px;
  vertical-align: -1px;
}
.OrderDetails .divbox {
  width: 95%;
  margin: 0 auto;
  margin-bottom: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
}
.OrderDetails h4 {
  height: 18px;
  padding-top: 18px;
  margin-left: 24px;
  font-size: 18px;
  font-family: "PingFang SC";
  font-weight: bold;
  color: #343434;
}
.OrderDetails .RequestInfo {
  /* height: 215px; */
  margin-top: 22px;
  /* padding-bottom: 20px; */
}
.OrderDetails .Blurb {
  width: 95%;
  /* height: 242px; */
  margin: 0 auto;
  margin-bottom: 20px;
  display: flex;
}
.OrderDetails .Information {
  /* height: 283px; */
  padding-bottom: 22px;
}
.OrderDetails .Blurb .tablebox {
  width: 49%;
  background: #ffffff;
  padding-bottom: 20px !important;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
}
.OrderDetails .Blurb .tablebox:nth-child(1) {
  margin-right: 2%;
}
.OrderDetails .divbox .RI_ul {
  display: flex;
}
.OrderDetails .divbox .RI_ul li {
  width: 31%;
  margin-left: 24px;
  margin-top: 20px;
}
.OrderDetails .divbox .RI_ul li:nth-child(1) {
  margin-left: 0;
}
.OrderDetails .divbox .RI_ul li:nth-child(2) {
  margin-left: 1%;
  margin-right: 1%;
}
.OrderDetails .divbox .RI_ul li p {
  margin-bottom: 19px;
  font-size: 14px;
  /* mar- */
}
.OrderDetails .divbox .RI_ul li p span {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}
.OrderDetails .divbox .RI_ul li p span:nth-child(1) {
  width: 90px;
  margin-right: 27px;
  color: #9a9a9a;
  text-align: right;
}
.OrderDetails .divbox .RI_ul li p span:nth-child(2) {
  width: 200px;
  height: 16px;
  color: #343434 !important;
  text-align: left;
}
.OrderDetails .Information .RI_ul li {
  margin-top: 0px;
}
/* element */
.OrderDetails .endtwotr {
  margin-top: -2px;
}
.OrderDetails .Information .el-timeline-item {
  padding-bottom: 30px;
}
.OrderDetails .Blurb .el-table td,
.el-table th {
  padding: 8px 0;
}
.OrderDetails .Information .el-table td,
.el-table th {
  padding: 7px 0;
}
.OrderDetails .el-tabs__item {
  font-size: 16px;
}
.OrderDetails .el-timeline-item__tail {
  position: absolute;
  left: 155px;
  top: 7px;
}
.OrderDetails .el-timeline-item__node--normal {
  left: 150px;
}
.OrderDetails .el-timeline-item__wrapper {
  width: 260px;
  padding-left: 175px;
  font-size: 14px;
  font-family: "PingFang SC";
  font-weight: 500;
  color: #333333;
}
.OrderDetails .el-timeline-item__timestamp.is-bottom {
  position: absolute;
  right: 295px;
  top: 3px;
  margin-top: 0;
  color: #999999;
  font-size: 11px;
}
.OrderDetails .el-tabs__nav-wrap::after {
  background: none;
}
.OrderDetails .el-table td,
.el-table th {
  text-align: center;
}
.OrderDetails .Blurb .el-table__header tr,
.OrderDetails .Blurb .el-table__header th {
  padding: 0;
  height: 38px;
  line-height: 38px;
}
.OrderDetails .Information .el-table__header tr,
.OrderDetails .Information .el-table__header th {
  padding: 0;
  height: 31px;
  line-height: 31px;
}
.OrderDetails .el-tabs__header {
  margin-left: 21px;
  padding-top: 5px;
  margin-bottom: 25px;
  font-size: 18px;
}
/* table 滚动条 */
.OrderDetails .el-table__body-wrapper::-webkit-scrollbar {
  width: 3px;
}
.OrderDetails .el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.OrderDetails .el-table__body-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/AirOrder/AirOrderDetail.vue